import React from 'react';
import './footer.css';

const Footer = () => {
  return (
    <div className="footer">
      <div className="footer-content">
        <div className="footer-left ">
          <h2>Empower your career with Internshala today</h2>
          <div className="footer-buttons">
            <button className="google-btn">Continue with Google</button>
            <button className="register-btn">Register now</button>
          </div>
        </div>
        <div className="footer-right">
          <div className="footer-section">
            <h3>Internships by places</h3>
            <ul>
              <li>Internship in India</li>
              <li>Internship in Delhi</li>
              <li>Internship in Bangalore</li>
              <li>Internship in Hyderabad</li>
              <li>Internship in Mumbai</li>
              <li>Internship in Chennai</li>
            </ul>
          </div>
          <div className="footer-section">
            <h3>Internship by Stream</h3>
            <ul>
              <li>Computer Science Internship</li>
              <li>Electronics Internship</li>
              <li>Mechanical Internship</li>
              <li>Civil Internship</li>
              <li>Marketing Internship</li>
              <li>Chemical Internship</li>
            </ul>
          </div>
          <div className="footer-section">
            <h3>Jobs by Places</h3>
            <ul>
              <li>Jobs in Delhi</li>
              <li>Jobs in Mumbai</li>
              <li>Jobs in Bangalore</li>
              <li>Jobs in Jaipur</li>
              <li>Jobs in Kolkata</li>
              <li>Jobs in Hyderabad</li>
            </ul>
          </div>
          <div className="footer-section">
            <h3>Jobs by Stream</h3>
            <ul>
              <li>Marketing jobs</li>
              <li>Content writing jobs</li>
              <li>Web development jobs</li>
              <li>Sales jobs</li>
              <li>Finance jobs</li>
              <li>Digital Marketing jobs</li>
            </ul>
          </div>
          <div className="footer-section">
            <h3>Placement Guarantee Courses</h3>
            <ul>
              <li>Full Stack Development course with placement</li>
              <li>Data Science course with placement</li>
              <li>Human Resource Management course with placement</li>
              <li>Digital Marketing course with placement</li>
              <li>Electric Vehicle course with placement</li>
              <li>UI/UX Design course with placement</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
